
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-for-farmers",
      function () {
        return require("private-next-pages/solution-for-farmers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-for-farmers"])
      });
    }
  